require('./myProfileKeysSignature.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const MyProfileKeysSignatureStep1 = require('components/myProfile/myProfileKeysSignature/myProfileKeysSignatureStep1/myProfileKeysSignatureStep1');
const MyProfileKeysSignatureEnd = require('components/myProfile/myProfileKeysSignature/myProfileKeysSignatureEnd/myProfileKeysSignatureEnd');
const MyProfileKeysSignatureEndFailure = require('components/myProfile/myProfileKeysSignature/myProfileKeysSignatureEndFailure/myProfileKeysSignatureEndFailure')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript , CONFIRMATION_SCRIPT_GREETING , CONFIRMATION_SCRIPT_AGREEMENT} = require('components/contactCenter/confirmScript/confirmationScript');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @constants
const { STEP_2_PROPS } = require('./constants/myProfileKeysSignatureProps');
const { REGENERATE_SIGNATURE_KEY_WITH_BIOCATCH } = require('constants/flagBasedFeatures.js');
import { KEYS_SIGNATURE_EVENT_TAG, KEYS_SIGNATURE_CATEGORY_ERROR } from 'constants/tagging'

const biocatch = require('constants/biocatch');
import { 
    LINK_CLICK_ACTION_EVENT,
    CANCEL_ACTION_EVENT,
    BUTTON_CLICK,
    MY_PROFILE_KEY_SIGNATURE_FINISH_TAG_EVENT,
    MY_PROFILE_KEY_SIGNATURE_SMS_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_SMS_TAG_EVENT,
    MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_CATEGORY_EVENT,
    MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_DESCRIPTION_EVENT
} from 'constants/tagging';

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");
import { recordLinkV2 } from 'utilities/tagging';

class MyProfileKeysSignature extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeFirstCode = this.handleChangeFirstCode.bind(this);
        this.handleChangeSecondCode = this.handleChangeSecondCode.bind(this);
        this.onResendClick = this.onResendClick.bind(this);
        this.onSMSInputClick = this.onSMSInputClick.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    onCancel() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: LINK_CLICK_ACTION_EVENT,
            etiquetaEvento: CANCEL_ACTION_EVENT 
        });
        this.props.onCancel();
    }

    onFinish() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: BUTTON_CLICK,
            etiquetaEvento: MY_PROFILE_KEY_SIGNATURE_FINISH_TAG_EVENT
        })
        this.props.onFinish();
    }

    onSMSInputClick() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_SMS_ACTION_EVENT,
            etiquetaEvento: MY_PROFILE_KEY_SIGNATURE_SMS_TAG_EVENT
        });
    }

    onResendClick() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_ACTION_EVENT,
            categoriaError: MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_CATEGORY_EVENT,
            descripcionError: MY_PROFILE_KEY_SIGNATURE_SMS_RESEND_DESCRIPTION_EVENT
        });
    }

    componentWillReceiveProps(nextProps) {
        const {
            immMyProfileKeysSignature,
        } = this.props;
        const visibleStep = immMyProfileKeysSignature.get('visibleStep');
        const nextVisibleStep = nextProps.immMyProfileKeysSignature.get('visibleStep');

        if(visibleStep !== nextVisibleStep && nextVisibleStep === 2){
            changeBiocatchContext(biocatch.CHALLENGE_PAGE);
        }
    }

    buildContent() {
        const { lowBiocatchAvailable, immVariables, immMyProfileKeysSignature, immFlagBasedFeatures, onRetryFailure } = this.props;
        let content = null;
        if (immMyProfileKeysSignature.get('isFetchingBiocatchScore') || immMyProfileKeysSignature.get('isFetching')) {
            content = <LoadingSection />;
        }
        if ((!!immMyProfileKeysSignature.get('biocatchScore') || !immFlagBasedFeatures.get(REGENERATE_SIGNATURE_KEY_WITH_BIOCATCH)) && !immMyProfileKeysSignature.get('submitSuccessful')) {
            content = this.buildWizard();
        }
        if (immMyProfileKeysSignature.get('submitSuccessful') && !immMyProfileKeysSignature.get('errorReceived')) {
            content = <MyProfileKeysSignatureEnd lowBiocatchAvailable={lowBiocatchAvailable} />;
        }
        if (immMyProfileKeysSignature.get('submitSuccessful') && immMyProfileKeysSignature.get('errorReceived')) {
            content = <MyProfileKeysSignatureEndFailure immVariables={immVariables} lowBiocatchAvailable={lowBiocatchAvailable} onRetryButtonClick={onRetryFailure} />;
        }
        return content;
    }

    buildWizard() {
        const {
            immFlagBasedFeatures,
            immMyProfileKeysSignature,
            lowBiocatchAvailable,
            validateStep,
            setVisibleStep,
            setWillCancel,
            updateFirstField,
            updateSecondField
        } = this.props;

        const immSteps = immMyProfileKeysSignature.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immMyProfileKeysSignature.get('visibleStep');
        const wizardClass = 'my-profile-keys-signature__wizard';
        const immFinalButton = 'signatureEdit-change';
        const operative = formatText('operatives-changeSignature');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const step2Title = STEP_2_PROPS[lowBiocatchAvailable].stepTitle ? (
            <h2 className='my-profile-keys-signature-step-2__title'>
                <FormattedText value={STEP_2_PROPS[lowBiocatchAvailable].stepTitle} />
            </h2>
        ) : null;

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                >
                    <MyProfileKeysSignatureStep1
                        lowBiocatchAvailable={lowBiocatchAvailable}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        immMyProfileKeysSignature={immMyProfileKeysSignature}
                        updateFirstField={updateFirstField}
                        updateSecondField={updateSecondField}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    {step2Title}
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>

                    <SignaturePattern
                        onSMSInputClick={this.onSMSInputClick}
                        onResendClick={this.onResendClick}
                        operationType={STEP_2_PROPS[lowBiocatchAvailable].signaturePatternOperationType}
                        operationParams={{}}
                        customEventTag={KEYS_SIGNATURE_EVENT_TAG}
                        customCategoryError={KEYS_SIGNATURE_CATEGORY_ERROR}
                        isResetSignature
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleChangeFirstCode(value, position) {
        this.props.updateFirstField(value, position);
    }

    handleChangeSecondCode(value, position) {
        this.props.updateSecondField(value, position);
    }

    render () {
        return this.buildContent();
    }
}

MyProfileKeysSignature.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMyProfileKeysSignature: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    lowBiocatchAvailable: PropTypes.string,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateFirstField: PropTypes.func.isRequired,
    updateSecondField: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onRetryFailure: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired
};

module.exports = MyProfileKeysSignature;